export default __webpack_public_path__ + "static/media/hide.a16a2c42.mp3";